var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { api } from "../../../../api/API";
import { sleep, useAsync2, useAsyncAction } from "nate-react-api-helpers";
import { useEffect, useRef } from "react";
import { useSnackAction } from "../../shopdrawing/hardware/SnackAction";
import { retryTransient } from "../../../../misc/RetryTransient";
export function useBackgroundTask(input) { const callbackRef = useRef(input.callback); callbackRef.current = input.callback; const onDoneRef = useRef(input.onDone); onDoneRef.current = input.onDone; const mountedRef = useRef(true); useEffect(() => { return () => { mountedRef.current = false; }; }, []); const loader = useAsync2((input) => __awaiter(this, void 0, void 0, function* () { const info = yield callbackRef.current(input); const done = yield pollBackgroundTask(info.task, mountedRef); if (!done)
    return; if (done.result.error)
    throw new Error(done.result.error); onDoneRef.current(done.result); return done.result; }), input.input, input.deps); return loader; } // polls the task until it's done. Returns null if the component unmounts first.
function pollBackgroundTask(task, mountedRef) {
    return __awaiter(this, void 0, void 0, function* () { yield sleep(500); while (true) {
        const status = yield retryTransient(() => api.util.getBackgroundTaskStatus({ task: task, withResult: true }));
        if (status.done) {
            return { result: status.result };
        }
        yield sleep(1000);
        if (!mountedRef.current) {
            return null;
        }
    } });
}
export function useBackgroundAction(input) { const callbackRef = useRef(input.callback); callbackRef.current = input.callback; const onDoneRef = useRef(input.onDone); onDoneRef.current = input.onDone; const onErrorRef = useRef(input.onError); onErrorRef.current = input.onError; const mountedRef = useRef(true); useEffect(() => { return () => { mountedRef.current = false; }; }, []); const loader = useAsyncAction((input) => __awaiter(this, void 0, void 0, function* () { const ref = { current: undefined }; const info = yield callbackRef.current(input, ref); const done = yield pollBackgroundTask(info.task, mountedRef); if (!done)
    return null; if (done.result.error) {
    if (onErrorRef.current)
        onErrorRef.current(done.result.error);
    throw new Error(done.result.error);
} if (onDoneRef.current)
    onDoneRef.current(done.result, ref); return done.result; }), []); return loader; }
export function useBackgroundActionSnack(input) { const callbackRef = useRef(input.callback); callbackRef.current = input.callback; const onDoneRef = useRef(input.onDone); onDoneRef.current = input.onDone; const onErrorRef = useRef(input.onError); onErrorRef.current = input.onError; const retryOnErrorRef = useRef(input.retryOnError); retryOnErrorRef.current = input.retryOnError; const mountedRef = useRef(true); useEffect(() => { return () => { mountedRef.current = false; }; }, []); const loader = useSnackAction((input) => __awaiter(this, void 0, void 0, function* () { const ref = { current: undefined }; let current = input; while (true) {
    const info = yield callbackRef.current(current, ref);
    const done = yield pollBackgroundTask(info.task, mountedRef);
    if (!done)
        return null;
    if (done.result.error) {
        const retryInput = retryOnErrorRef.current ? yield retryOnErrorRef.current(done.result.error, current) : undefined;
        if (retryInput !== undefined) {
            current = retryInput;
            continue;
        }
        if (onErrorRef.current)
            onErrorRef.current(done.result.error);
        throw new Error(done.result.error);
    }
    if (onDoneRef.current)
        onDoneRef.current(done.result, ref);
    return done.result;
} }), { success: input.successMessage || "Success!" }); return loader; }
